import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  roomItemName: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "22px",
    color: "#465869",
  },

  roomInputName: {
    background: "transparent",
    border: "none",
    borderBottom: "1px solid #f2f2f2",
  },

  textInfoRoom: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#465869",
  },

  roomItemInfo: {
    listStyle: "none",
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& li": {
      margin: 0,
      position: "relative",
      "&:not(:last-child)": {
        paddingRight: "1rem",
        marginRight: "1rem",
        "&:after": {
          content: "''",
          position: "absolute",
          width: 2,
          height: "100%",
          top: 0,
          right: 0,
          backgroundColor: "#CCDEEE",
        },
      },
    },
  },

  mainHeaderTitle: {
    display: "flex",
    alignItems: "center",
  },

  menuItem: {
    "&:hover": {
      backgroundColor: "#EDF5FB !important",
      color: "#308CDB !important",
    },
  },
  menuItemDelete: {
    color: "#F97066 !important",

    "&:hover": {
      backgroundColor: "#FEE4E2 !important",
      color: "#F97066 !important",
    },
  },

  sectionItemsInfo: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "flex-end",
    gap: "10px",
  },
}));

export default styles;
